var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('WhitePage',{attrs:{"loading":_vm.loading}},[_c('title-bar',[_vm._v("キャラクター管理")]),_c('div',{attrs:{"id":"manage"}},[_c('select-list',{attrs:{"items":_vm.list,"fields":[
        { key: 'eno', label: 'ENo', sortable:true },
        { key: 'icon', label: '' },
        { key: 'name', label: '名前', sortable:true, filterType:'string' },
        { key: 'str', label: 'STR', sortable:true },
        { key: 'int', label: 'INT', sortable:true },
        { key: 'vit', label: 'VIT', sortable:true },
        { key: 'mnd', label: 'MND', sortable:true },
        { key: 'dex', label: 'DEX', sortable:true },
        { key: 'agi', label: 'AGI', sortable:true },
        { key: 'hp', label: 'HP', sortable:true },
        { key: 'area', label: '現在地', filterType:'string' }
      ],"perPage":20,"tableKey":"eno","selectable":false,"tableClass":"manage-table"},scopedSlots:_vm._u([{key:"cell(icon)",fn:function(row){return [_c('router-link',{attrs:{"to":'/editchara/'+row.item.eno}},[_c('b-img',{attrs:{"thumbnail":"","src":row.item.icon||'./img/noimage.png',"width":"60px","height":"60px"}})],1)]}}])})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }